export default __webpack_public_path__ + "static/media/hashkey-2.caff6375.png";